import { Container } from '@pixi/react'
import { soundManager, SoundType } from '../../domain/sound/SoundManager'
import { useTurboStore } from '../../domain/turbo/turboStore'
import { ButtonProps } from '../menu/interface/ButtonProps'
import { Button } from '../../UI/Button'

export const TurboButton = (props: ButtonProps) => {
  const isTurbo = useTurboStore(x => x.isTurbo)

  const onPress = () => {
    useTurboStore.setState({ isTurbo: !isTurbo })
  }

  return (
    <Container position={[props.x, props.y]}>
      {
        isTurbo
          ? (
              <Button
                name="turbo off Button"
                defaultView="turbo_enable_on"
                hoverView="turbo_off_hover"
                pressedView="turbo_off_click"
                disabledView="turbo_disabled"
                enabled={!props.disabled}
                x={0}
                y={0}
                width={props.width}
                height={props.height}
                key="off"
                onPressing={() => {
                  soundManager.play(SoundType.buttonConfirm)
                }}
                onPress={onPress}
              />
            )
          : (
              <Button
                name="turbo on Button"
                defaultView="turbo_on_normal"
                hoverView="turbo_on_hover"
                pressedView="turbo_on_click"
                disabledView="turbo_disabled"
                enabled={!props.disabled}
                x={0}
                y={0}
                width={props.width}
                height={props.height}
                key="on"
                onPressing={() => {
                  soundManager.play(SoundType.buttonConfirm)
                }}
                onPress={onPress}
              />
            )

      }
    </Container>
  )
}
